// test1704
(1704 && 0);
